;(function () {
  angular
    .module('contrast.validation')
    .directive('validRegex', function ($translate) {
      'ngInject'

      var REGEX_PATTERN_MAX_LIMIT = 1000

      return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
          regex: '=',
          regexError: '='
        },
        link: function (scope, elem, attrs, ctrl) {
          scope.$watch('regex', function (value) {
            if (angular.isDefined(value)) {
              var validationResult = {
                result: value.length <= REGEX_PATTERN_MAX_LIMIT,
                message: $translate.instant(
                  'detail_securityControl_regexMaxLimit',
                  { maxLimit: REGEX_PATTERN_MAX_LIMIT }
                )
              }
              ctrl.$setValidity('validRegex', validationResult.result)
              scope.regexError = validationResult.message
            }
            return value
          })
        }
      }
    })
})()
